enum DmsSyncType {
  UNKNOWN = 'unknown',
  INSTANT = 'instant',
  LAZY = 'lazy',
}

export default DmsSyncType;